module.exports = __webpack_public_path__ + "static/img/13-3.ce83707.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/13-3.jpg
// module id = ky0u
// module chunks = 0